import React, { useId } from "react";

export function Printicon({ classes }) {
  return (
    <span className={`${classes} fs-17 icon-Group-7668`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span></span>
  )
}
export function PdfIcon({ classes }) {
  return (
    <span className={`${classes} icon-pdf-followup `}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
  )
}
export function PDF({ classes }) {
  return (
    <span className={`icon-pdf-chatbot ${classes || 'fs-28'}`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span></span>
  )
}
export function Textfile({ classes }) {
  return (
    <span className={`icon-txt-svgrepo-com ${classes || 'fs-24'} `}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
  )
}
export function CheckList({ classes }) {
  return (
    <span className={`${classes} icon-checklist `}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span><span className="path17"></span><span className="path18"></span><span className="path19"></span><span className="path20"></span><span className="path21"></span></span>
  )
}
export function MultiChoiceIcon({ classes }) {
  return (
    <span className={`${classes} icon-multichoice`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span></span>
  )
}
export function DateIcon({ classes }) {
  return (
    <span className={`${classes} icon-calendar-svgrepo-com`}>
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
      <span className="path4"></span>
    </span>
  )
}

export function HeadingIcon({ classes }) {
  return (
    <span className={`${classes} icon-heading fs-21`}>
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
  )
}

export function SimpleQuestionIcon({ classes }) {
  return (
    <span className={`${classes} icon-question`}>
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
  )
}

export function SingleChoiceIcon({ classes }) {
  return (
    <span className={`${classes} icon-single-choice`}>
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
  )
}

export function RatingScaleIcon({ classes }) {
  return (
    <span className={`${classes} icon-rating-scale fs-19`}>
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
  )
}

export function NotesIcon({ classes }) {
  return (
    <span className={`${classes} icon-Notes fs-19`}>
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
  )
}

export function TableIcon({ classes }) {
  return (
    <span className={`${classes} icon-Table`}>
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
    </span>
  )
}

export function ImageIcon({ classes }) {
  return (
    <span className={`${classes} icon-image-template`}>
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
    </span>
  )
}

export function DragIcon({ classes }) {
  return (
    <span className={`${classes} icon-Drag fs-89`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span><span className="path17"></span><span className="path18"></span><span className="path19"></span><span className="path20"></span><span className="path21"></span><span className="path22"></span><span className="path23"></span><span className="path24"></span><span className="path25"></span><span className="path26"></span><span className="path27"></span><span className="path28"></span><span className="path29"></span><span className="path30"></span><span className="path31"></span><span className="path32"></span><span className="path33"></span><span className="path34"></span><span className="path35"></span><span className="path36"></span><span className="path37"></span><span className="path38"></span><span className="path39"></span><span className="path40"></span><span className="path41"></span><span className="path42"></span><span className="path43"></span><span className="path44"></span><span className="path45"></span><span className="path46"></span><span className="path47"></span><span className="path48"></span><span className="path49"></span><span className="path50"></span></span>
  )
}
export function EncounterIcon({ classes }) {
  return (
    <span className={`${classes} icon-Encounter fs-20`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span></span>
  )
}
export function IntakeFile({ classes }) {
  return (
    <span className={`${classes} icon-file fs-19`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span></span>
  )
}
export function IntakeText({ classes }) {
  return (
    <span className={`${classes} icon-text fs-19`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></span>
  )
}
export function ClaimNotes({ classes }) {
  return (
    <span className={`${classes} icon-claim-notes fs-21`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span></span>
  )
}
export function InsurancePatientIcon({ classes }) {
  return (
    <span className={`${classes} icon-insurance-patient`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span></span>
  )
}
export function HelpIcon({ classes }) {
  return (
    <span className={`${classes} icon-Help-icon`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span></span>)
}
export function IntakeDownload({ classes }) {
  return (
    <span className={`${classes} icon-Intakedownload fs-15`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span></span>
  )
}
export function NoteIcon({ classes }) {
  return (
    <span className={`${classes} icon-note-icon fs-14`}><span className="path1"></span><span className="path2"></span></span>
  )
}
export function NoNotificationIcon({ classes }) {
  return (
    <span className={`${classes} icon-no-notification fs-48`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span><span className="path17"></span><span className="path18"></span></span>
  )
}
export function NoHistoryIcon({ classes }) {
  return (
    <span className={`${classes} icon-history`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span><span className="path17"></span><span className="path18"></span></span>
  )
}
export function IconAngleRight({ classes }) {
  return (
    <span className={`${classes} icon-check-angle-right fs-10`}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
  )
}
export function IconAngleBottom({ classes }) {
  return (
    <span className={`${classes} icon-check-angle-bottom fs-10`}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
  )
}
export function IconBlinkers({ classes }) {
  return (
    <span className={`${classes} icon-blinker fs-16`}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
  )
}

export function IconDisable({ classes }) {
  return (
    <span className={`${classes} icon-disable fs-13`}><span className="path1"></span><span className="path2"></span></span>
  )
}
export function IconPatCollapse({ classes }) {
  return (
    <span className={`${classes} icon-pat-collapse fs-20`}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
  )
}
export function IconPatExpand({ classes }) {
  return (
    <span className={`${classes} icon-pat-expand fs-20`}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
  )
}

export function IconGeneral({ classes }) {
  return (
    <span className={`${classes} icon-General fs-16`}><span className="path1"></span><span className="path2"></span></span>
  )
}

export function IconSettingPreference({ classes }) {
  return (
    <span className={`${classes} icon-settings-preferences`}><span className="path1"></span> <span className="path2"></span>  <span className="path3"></span>  <span className="path4"></span>  <span className="path5"></span>  <span className="path6"></span><span className="path7"></span><span className="path8"></span> <span className="path9"></span></span>
  )
}
export function IconEnabled({ classes }) {
  return (
    <span className={`${classes} icon-enabled fs-15`}><span className="path1"></span><span className="path2"></span></span>
  )
}

export function IconAppintmentNotFound({ classes }) {
  return (
    <span className={`${classes} icon-apt-not-found fs-25`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span><span className="path17"></span><span className="path18"></span><span className="path19"></span><span className="path20"></span><span className="path21"></span><span className="path22"></span><span className="path23"></span><span className="path24"></span><span className="path25"></span><span className="path26"></span><span className="path27"></span><span className="path28"></span><span className="path29"></span><span className="path30"></span><span className="path31"></span><span className="path32"></span><span className="path33"></span><span className="path34"></span><span className="path35"></span><span className="path36"></span><span className="path37"></span><span className="path38"></span><span className="path39"></span><span className="path40"></span><span className="path41"></span><span className="path42"></span></span>
  )
}
export function IconSignature({ classes }) {
  return (
    <span className={`${classes} icon-signature-icon fs-15"`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span><span className="path17"></span><span className="path18"></span><span className="path19"></span><span className="path20"></span></span>
  )
}
export function IconAudit({ classes }) {
  return (
    <span className={`${classes} icon-menu-1`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span></span>
  )
}

export function IconPlusBg({ classes }) {
  return (
    <span className={`${classes} icon-plus-bg`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span></span>
  )
}

export function IconClaimMenu({ classes }) {
  return (
    <span className={`${classes} icon-claims-new`}><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span></span>
  )
}

export function IconTemplate({ classes }) {
  return (
    <span className={`${classes} icon-template-library`}><span className="path1"></span><span className="path2"></span><span className="path3"></span></span>
  )
}

export function IconDropdown({ classes }) {
  return (
    <span className={`${classes} icon-dropdown-template `}><span className="path1"></span><span className="path2"></span></span>
  )
}

export function IconProcedureCodes({ classes }) {
  return (
    <span className={`${classes} icon-Procedure-Codes fs-11`}><span className="path1"></span><span className="path2"></span>
      <span className="path3"></span></span>
  )
}

export function IconQualityCare({ classes }) {
  return (
    <span className={`${classes} icon-Quality-Care fs-11`}><span className="path1"></span><span className="path2"></span>
      <span className="path3"></span></span>
  )
}

export function IconFollowUp({ classes }) {
  return (
    <span className={`${classes} icon-Follow-Up fs-11`}><span className="path1"></span><span className="path2"></span>
      <span className="path3"></span><span className="path4"></span></span>
  )
}

export function IconStatementSent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
      <path d="M7.68123 11.9316L9.09748 13.3478L11.93 10.5153M6.26498 0.601563H2.86598C2.0728 0.601563 1.67621 0.601562 1.37326 0.755927C1.10677 0.891703 0.890116 1.10836 0.75434 1.37485C0.599976 1.6778 0.599976 2.07439 0.599976 2.86756V11.0818C0.599976 11.875 0.599976 12.2716 0.75434 12.5745C0.890116 12.841 1.10677 13.0577 1.37326 13.1934C1.67621 13.3478 2.0728 13.3478 2.86598 13.3478H5.20279M6.26498 0.601563L10.5137 4.85031M6.26498 0.601563V3.71731C6.26498 4.1139 6.26498 4.3122 6.34216 4.46367C6.41007 4.59691 6.51834 4.70524 6.65161 4.77314C6.80308 4.85031 7.00136 4.85031 7.39798 4.85031H10.5137M10.5137 4.85031V7.96606M3.43248 10.5153H5.20279M3.43248 7.68281H7.68123M3.43248 4.85031H4.1406" stroke="#05AA15" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export function IconDownload() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 4.22876 -9.53674e-08 2.34314 1.17158 1.17158C2.34314 -9.53674e-08 4.22876 0 8 0C11.7712 0 13.6569 -9.53674e-08 14.8284 1.17158C16 2.34314 16 4.22876 16 8C16 11.7712 16 13.6569 14.8284 14.8284C13.6569 16 11.7712 16 8 16C4.22876 16 2.34314 16 1.17158 14.8284C-9.53674e-08 13.6569 0 11.7712 0 8ZM8 3.4C8.33136 3.4 8.6 3.66863 8.6 4V8.15144L9.97576 6.77576C10.2101 6.54144 10.5899 6.54144 10.8242 6.77576C11.0586 7.01008 11.0586 7.38992 10.8242 7.62424L8.42424 10.0242C8.31176 10.1368 8.15912 10.2 8 10.2C7.84088 10.2 7.68824 10.1368 7.57576 10.0242L5.17574 7.62424C4.94142 7.38992 4.94142 7.01008 5.17574 6.77576C5.41005 6.54144 5.78995 6.54144 6.02426 6.77576L7.4 8.15144V4C7.4 3.66863 7.66864 3.4 8 3.4ZM4.8 11.4C4.46863 11.4 4.2 11.6686 4.2 12C4.2 12.3314 4.46863 12.6 4.8 12.6H11.2C11.5314 12.6 11.8 12.3314 11.8 12C11.8 11.6686 11.5314 11.4 11.2 11.4H4.8Z" fill="#18181B" />
    </svg>
  )
}

export function IconAlert({ height = 16 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={height} height={height} viewBox="0 0 18 18" fill="none">
      <path d="M9 12.5556H9.00889M9 5.44444V9M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#FF2C2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export function IconAlertGradient({ width = 16, height = 16 }) {
  const gradientId = useId();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path d="M8.01548 11.1328H8.02328M8.01548 4.89722V8.015M8.01548 15.03C11.8901 15.03 15.031 11.8893 15.031 8.015C15.031 4.14072 11.8901 1 8.01548 1C4.14094 1 1 4.14072 1 8.015C1 11.8893 4.14094 15.03 8.01548 15.03Z" stroke={`url(#${gradientId})`} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id={gradientId} x1="8.01548" y1="1" x2="8.01548" y2="15.03" gradientUnits="userSpaceOnUse">
          <stop offset="0.09" stop-color="#5792EA" />
          <stop offset="1" stop-color="#7469ED" />
        </linearGradient>
      </defs>
    </svg>
  )
}



export function IconPause({ width = 6, height = 8 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 6 8" fill="none">
      <path d="M0.75 0.75V6.9275M4.28 0.75V6.9275" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export function IconResumeAiSession({ width = 14, height = 14 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14" fill="none">
      <path d="M0.75 5.24606V7.81523M3.70341 2.67688V10.3844M6.65683 0.75V12.3113M9.61024 2.67688V10.3844M12.5637 5.24606V7.81523" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}


export function IconAdditionalInfo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.37115 0.703125C8.35197 4.35061 7.89499 6.27608 6.00019 6.47954C2.66847 6.47954 1.61658 8.5202 2.05856 9.54319C2.50054 10.5662 3.88855 11.3704 5.0254 11.5649C6.16225 11.7595 8.00476 11.7748 10.3052 9.54319C12.6057 7.31157 10.9716 3.71018 10.3052 2.76576C9.86098 2.13614 8.88296 1.4486 7.37115 0.703125Z" fill="#434343" fillOpacity="0.23" /><path d="M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM6 11.04C8.78352 11.04 11.04 8.78352 11.04 6C11.04 3.21648 8.78352 0.96 6 0.96C3.21648 0.96 0.96 3.21648 0.96 6C0.96 8.78352 3.21648 11.04 6 11.04ZM5.45455 5.45455C5.45455 5.1533 5.69875 4.90909 6 4.90909C6.30125 4.90909 6.54545 5.1533 6.54545 5.45455V8.18182C6.54545 8.48306 6.30125 8.72727 6 8.72727C5.69875 8.72727 5.45455 8.48306 5.45455 8.18182V5.45455ZM6 4.36364C5.69875 4.36364 5.45455 4.11943 5.45455 3.81818C5.45455 3.51694 5.69875 3.27273 6 3.27273C6.30125 3.27273 6.54545 3.51694 6.54545 3.81818C6.54545 4.11943 6.30125 4.36364 6 4.36364Z" fill="#434343" /></svg>
  )
}

export function IconVitals() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M4.07171 10.7049H7.13319C9.68441 10.7049 10.7049 9.68439 10.7049 7.13317V4.07171C10.7049 1.52049 9.68441 0.5 7.13319 0.5H4.07171C1.52049 0.5 0.5 1.52049 0.5 4.07171V7.13317C0.5 9.68439 1.52049 10.7049 4.07171 10.7049Z" stroke="#434343" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M0.5 5.96156L3.56146 5.95135C3.94415 5.95135 4.37275 6.24219 4.51562 6.59936L5.09731 8.06886C5.22998 8.40052 5.43918 8.40052 5.57184 8.06886L6.7403 5.10435C6.85255 4.81861 7.06175 4.8084 7.20462 5.07883L7.73528 6.08401C7.89345 6.38506 8.30165 6.62998 8.63841 6.62998H10.71" stroke="#434343" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
export function IconAudio() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M2.70035 11.5023C3.91557 11.5023 4.90069 10.5154 4.90069 9.29802C4.90069 8.08066 3.91557 7.09375 2.70035 7.09375C1.48513 7.09375 0.5 8.08066 0.5 9.29802C0.5 10.5154 1.48513 11.5023 2.70035 11.5023Z" fill="black" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9.30484 10.4242C10.52 10.4242 11.5052 9.43732 11.5052 8.2199C11.5052 7.00253 10.52 6.01562 9.30484 6.01562C8.08964 6.01562 7.10449 7.00253 7.10449 8.2199C7.10449 9.43732 8.08964 10.4242 9.30484 10.4242Z" fill="black" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.90137 9.32577V4.41097C4.90086 3.62846 5.17683 2.87103 5.68035 2.27321C6.18381 1.67539 6.88221 1.27583 7.65162 1.14541L11.502 0.5V8.22255" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}


export function IconAiSingle() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
      <path d="M0.366799 4.75353C-0.122266 4.56056 -0.122266 3.86832 0.366799 3.67535L2.506 2.83174C2.65541 2.77282 2.77362 2.6546 2.83254 2.50519L3.67616 0.365992C3.86913 -0.123074 4.56137 -0.123074 4.75433 0.365992L5.59795 2.50519C5.65687 2.6546 5.77508 2.77282 5.92449 2.83174L8.0637 3.67535C8.55276 3.86832 8.55276 4.56056 8.0637 4.75353L5.92449 5.59714C5.77508 5.65606 5.65687 5.77428 5.59795 5.92369L4.75433 8.06289C4.56137 8.55195 3.86913 8.55195 3.67616 8.06289L2.83254 5.92369C2.77362 5.77428 2.65541 5.65606 2.506 5.59714L0.366799 4.75353Z" fill="url(#paint0_linear_24944_7293)" />
      <defs>
        <linearGradient id="paint0_linear_24944_7293" x1="0" y1="4.21444" x2="8.4305" y2="4.21444" gradientUnits="userSpaceOnUse">
          <stop offset="0.09" stop-color="#5792EA" />
          <stop offset="1" stop-color="#7469ED" />
        </linearGradient>
      </defs>
    </svg>
  )
}



export function IconCopy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
      <path d="M0.5 9.09765V1.72824C0.5 1.0499 1.0499 0.5 1.72824 0.5H7.86941M4.18471 12.7824H9.71176C10.3901 12.7824 10.94 12.2325 10.94 11.5541V4.18471C10.94 3.50637 10.3901 2.95647 9.71176 2.95647H4.18471C3.50637 2.95647 2.95647 3.50637 2.95647 4.18471V11.5541C2.95647 12.2325 3.50637 12.7824 4.18471 12.7824Z" stroke="#18181B" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}



export function IconAddPlus() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M7.815 15.63C12.1311 15.63 15.63 12.1311 15.63 7.815C15.63 3.49889 12.1311 0 7.815 0C3.49889 0 0 3.49889 0 7.815C0 12.1311 3.49889 15.63 7.815 15.63Z" fill="#DBDBDB" />
      <path d="M7.81641 3.86914C8.02886 3.86917 8.20117 4.04145 8.20117 4.25391V11.332C8.20094 11.5443 8.02871 11.7168 7.81641 11.7168C7.60408 11.7168 7.43188 11.5443 7.43164 11.332V4.25391C7.43164 4.04143 7.60393 3.86914 7.81641 3.86914Z" fill="#DBDBDB" stroke="var(--BlueColor)" />
      <path d="M8.11227 4.24803C8.11227 4.08516 7.98024 3.95312 7.81737 3.95312C7.65449 3.95312 7.52246 4.08516 7.52246 4.24803V11.3258C7.52246 11.4886 7.65449 11.6207 7.81737 11.6207C7.98024 11.6207 8.11227 11.4886 8.11227 11.3258V4.24803Z" fill="#DBDBDB" stroke="var(--BlueColor)" />
      <path d="M11.7402 7.79883C11.7402 8.01128 11.5679 8.18359 11.3555 8.18359H4.27734C4.06509 8.18336 3.8926 8.01113 3.89258 7.79883C3.89258 7.5865 4.06507 7.4143 4.27734 7.41406H11.3555C11.5679 7.41406 11.7402 7.58635 11.7402 7.79883Z" fill="#DBDBDB" stroke="var(--BlueColor)" />
      <path d="M11.3477 8.08395C11.5105 8.08395 11.6426 7.95192 11.6426 7.78905C11.6426 7.62617 11.5105 7.49414 11.3477 7.49414L4.26994 7.49414C4.10707 7.49414 3.97503 7.62617 3.97503 7.78905C3.97503 7.95192 4.10707 8.08395 4.26994 8.08395H11.3477Z" fill="#DBDBDB" stroke="var(--BlueColor)" />
    </svg>
  )
}



export function ViewEncounterIcon({ width = 14, height = 16 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 16" fill="none">
      <path d="M10.2333 14.4669C10.2333 14.8568 9.91746 15.1726 9.52756 15.1726H1.05875C0.668821 15.1726 0.353027 14.8568 0.353027 14.4669V2.4694C0.353027 2.07947 0.668855 1.76367 1.05875 1.76367H9.52756C9.91749 1.76367 10.2333 2.0795 10.2333 2.4694V14.4669Z" fill="white" />
      <path d="M9.52741 15.5268H1.0586C0.474948 15.5268 0 15.0518 0 14.4682V2.47071C0 1.88706 0.474948 1.41211 1.0586 1.41211H9.52741C10.1111 1.41211 10.586 1.88706 10.586 2.47071V14.4682C10.586 15.0518 10.1111 15.5268 9.52741 15.5268ZM1.0586 2.11783C0.864183 2.11783 0.705723 2.27626 0.705723 2.47071V14.4682C0.705723 14.6626 0.864183 14.8211 1.0586 14.8211H9.52741C9.72183 14.8211 9.88029 14.6626 9.88029 14.4682V2.47071C9.88029 2.27626 9.72183 2.11783 9.52741 2.11783H1.0586Z" fill="#004762" />
      <path d="M8.46847 14.1147H2.11686C1.72693 14.1147 1.41113 13.7989 1.41113 13.409V3.17578H9.17422V13.4089C9.17419 13.7989 8.8584 14.1147 8.46847 14.1147Z" fill="#D8EFF7" />
      <path d="M8.82153 3.17644H1.76416V2.47072C1.76416 1.30133 2.71197 0.353516 3.88136 0.353516H6.70429C7.87368 0.353516 8.82149 1.30133 8.82149 2.47072V3.17644H8.82153Z" fill="#3AADD9" />
      <path d="M8.82138 3.52868H1.76401C1.56923 3.52868 1.41113 3.37059 1.41113 3.1758V2.47008C1.41117 1.10799 2.51916 0 3.88121 0H6.70414C8.0662 0 9.17422 1.10799 9.17422 2.47008V3.1758C9.17422 3.37059 9.01616 3.52868 8.82138 3.52868ZM2.11689 2.82293H8.4685V2.47008C8.4685 1.49723 7.67703 0.705756 6.70417 0.705756H3.88125C2.90836 0.705723 2.11689 1.49723 2.11689 2.47008V2.82293Z" fill="#004762" />
      <path d="M8.11592 5.29365H2.47007C2.27528 5.29365 2.11719 5.13555 2.11719 4.94077C2.11719 4.74599 2.27528 4.58789 2.47007 4.58789H8.11595C8.31074 4.58789 8.46883 4.74599 8.46883 4.94077C8.46883 5.13555 8.3107 5.29365 8.11592 5.29365Z" fill="#004762" />
      <path d="M5.29299 7.05729H2.47007C2.27528 7.05729 2.11719 6.89919 2.11719 6.70441C2.11719 6.50962 2.27528 6.35156 2.47007 6.35156H5.29299C5.48778 6.35156 5.64587 6.50966 5.64587 6.70444C5.64587 6.89922 5.48778 7.05729 5.29299 7.05729Z" fill="#004762" />
      <path d="M8.11592 7.05729H6.70444C6.50966 7.05729 6.35156 6.89919 6.35156 6.70441C6.35156 6.50962 6.50969 6.35156 6.70447 6.35156H8.11595C8.31074 6.35156 8.46883 6.50966 8.46883 6.70444C8.46883 6.89922 8.3107 7.05729 8.11592 7.05729Z" fill="#004762" />
      <path d="M8.11575 8.82099H5.29282C5.09804 8.82099 4.93994 8.6629 4.93994 8.46811C4.93994 8.27333 5.09804 8.11523 5.29282 8.11523H8.11575C8.31053 8.11523 8.46862 8.27333 8.46862 8.46811C8.46862 8.6629 8.31053 8.82099 8.11575 8.82099Z" fill="#004762" />
      <path d="M3.88151 8.82099H2.47003C2.27528 8.82099 2.11719 8.6629 2.11719 8.46811C2.11719 8.27333 2.27528 8.11523 2.47007 8.11523H3.88155C4.07633 8.11523 4.23442 8.27333 4.23442 8.46811C4.23442 8.6629 4.07629 8.82099 3.88151 8.82099Z" fill="#004762" />
      <path d="M8.11575 12.3503H5.29282C5.09804 12.3503 4.93994 12.1922 4.93994 11.9974C4.93994 11.8026 5.09804 11.6445 5.29282 11.6445H8.11575C8.31053 11.6445 8.46862 11.8026 8.46862 11.9974C8.46862 12.1922 8.31053 12.3503 8.11575 12.3503Z" fill="#004762" />
      <path d="M3.88155 12.3503H2.47007C2.27528 12.3503 2.11719 12.1922 2.11719 11.9974C2.11719 11.8026 2.27528 11.6445 2.47007 11.6445H3.88155C4.07633 11.6445 4.23442 11.8026 4.23442 11.9974C4.23442 12.1922 4.07633 12.3503 3.88155 12.3503Z" fill="#004762" />
      <path d="M5.29299 10.5866H2.47007C2.27528 10.5866 2.11719 10.4285 2.11719 10.2337C2.11719 10.039 2.27528 9.88086 2.47007 9.88086H5.29299C5.48778 9.88086 5.64587 10.039 5.64587 10.2337C5.64587 10.4285 5.48778 10.5866 5.29299 10.5866Z" fill="#004762" />
      <path d="M8.11592 10.5866H6.70444C6.50966 10.5866 6.35156 10.4285 6.35156 10.2337C6.35156 10.039 6.50966 9.88086 6.70444 9.88086H8.11592C8.3107 9.88086 8.4688 10.039 8.4688 10.2337C8.4688 10.4285 8.3107 10.5866 8.11592 10.5866Z" fill="#004762" />
      <path d="M10.2331 11.2923C11.7921 11.2923 13.056 10.0285 13.056 8.46941C13.056 6.91035 11.7921 5.64648 10.2331 5.64648C8.67402 5.64648 7.41016 6.91035 7.41016 8.46941C7.41016 10.0285 8.67402 11.2923 10.2331 11.2923Z" fill="#3AADD9" />
      <path d="M10.2329 11.6446C8.48201 11.6446 7.05713 10.2197 7.05713 8.46877C7.05713 6.71785 8.48201 5.29297 10.2329 5.29297C11.9839 5.29297 13.4087 6.71785 13.4087 8.46877C13.4087 10.2197 11.9839 11.6446 10.2329 11.6446ZM10.2329 5.99869C8.87088 5.99869 7.76285 7.10668 7.76285 8.46877C7.76285 9.83086 8.87084 10.9389 10.2329 10.9389C11.595 10.9389 12.703 9.83083 12.703 8.46877C12.703 7.10672 11.595 5.99869 10.2329 5.99869Z" fill="#004762" />
      <path d="M10.2328 9.52695C10.1397 9.52695 10.0497 9.49026 9.98338 9.42357L8.92478 8.36497C8.78679 8.22698 8.78679 8.00398 8.92478 7.866C9.06276 7.72802 9.28576 7.72802 9.42374 7.866L10.1626 8.6049L10.9887 7.22803C11.0889 7.06077 11.3056 7.00678 11.4729 7.10698C11.6401 7.20719 11.6941 7.42387 11.5939 7.59113L10.5353 9.35545C10.4796 9.44861 10.3836 9.5107 10.2759 9.52413C10.2618 9.52625 10.2473 9.52695 10.2328 9.52695Z" fill="#004762" />
    </svg>
  )
}